"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import { SmoothScrollProvider } from "@/components/motion/SmoothScrollProvider";

/** Routes that benefit from Lenis smooth scroll + GSAP ScrollTrigger sync. */
function shouldEnableSmoothScroll(pathname: string): boolean {
  return pathname === "/" || pathname === "/programs";
}

interface ScrollShellProps {
  children: ReactNode;
}

export function ScrollShell({ children }: ScrollShellProps) {
  const pathname = usePathname();
  const smoothScrollEnabled = shouldEnableSmoothScroll(pathname);

  return (
    <SmoothScrollProvider smoothScrollEnabled={smoothScrollEnabled}>
      {children}
    </SmoothScrollProvider>
  );
}
